import { render, staticRenderFns } from "./PostalCodeEditor.vue?vue&type=template&id=0e6ca817&"
import script from "./PostalCodeEditor.vue?vue&type=script&lang=ts&"
export * from "./PostalCodeEditor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports